<div class="edit-form-container">
  <div class="banner" *ngIf="!isFormComplete">
    <div class="banner-icon">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="10" cy="10" r="10" fill="#FFF4EB" />
        <circle cx="10" cy="10" r="8.33333" fill="#F57600" />
        <path
          d="M10 12.5V10M10 7.5H10.0083"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="banner-text">
      <p class="title">Complete Appointment Details</p>
      <p class="description">Add the following information to confirm the appointment.</p>
    </div>
  </div>

  <form [formGroup]="appointmentForm" class="form-grid">
    <div class="form-field">
      <label for="location">Location<span class="required">*</span></label>
      <mat-select
        formControlName="location"
        placeholder="Select location"
        (selectionChange)="onLocationChange($event.value)"
        [class.error]="
          appointmentForm.get('location')?.errors && appointmentForm.get('location')?.touched
        "
      >
        <mat-option *ngFor="let location of locations" [value]="location.value">{{
          location.label
        }}</mat-option>
      </mat-select>
      <div class="error-message" *ngIf="getFieldError('location')">
        {{ getFieldError('location') }}
      </div>
    </div>

    <div class="form-field">
      <label for="staff">Staff<span class="required">*</span></label>
      <mat-select
        formControlName="staff"
        placeholder="Select staff"
        [disabled]="!appointmentForm.get('location')?.value"
        [class.error]="
          appointmentForm.get('staff')?.errors && appointmentForm.get('staff')?.touched
        "
      >
        <mat-option *ngFor="let option of staffOptions" [value]="option.value">{{
          option.label
        }}</mat-option>
      </mat-select>
      <div class="error-message" *ngIf="getFieldError('staff')">
        {{ getFieldError('staff') }}
      </div>
    </div>

    <div class="form-field">
      <label for="date-time">Date & Time<span class="required">*</span></label>
      <div class="custom-select">
        <app-custom-date-picker
          formControlName="date"
          [timeSlots]="timeSlots"
          [locationDetails]="locationDetails"
          placeholder="Select date and time"
          [fixedOverlay]="true"
          [class.error]="
            appointmentForm.get('date')?.errors && appointmentForm.get('date')?.touched
          "
        >
        </app-custom-date-picker>
      </div>
      <div class="timezone-warning" *ngIf="showShopTimezoneWarning">
        <p>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8.99935" cy="9.00033" r="8.33333" fill="#F57600" />
            <path
              d="M8.99203 11.5H8.99951"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9 9L9 5.66667"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Scheduling is done in the shop timezone.
        </p>
      </div>
      <div class="error-message" *ngIf="getFieldError('date')">
        {{ getFieldError('date') }}
      </div>
    </div>

    <div class="form-field">
      <label for="duration">Duration<span class="required">*</span></label>
      <mat-select
        formControlName="duration"
        placeholder="Select duration"
        [class.error]="
          appointmentForm.get('duration')?.errors && appointmentForm.get('duration')?.touched
        "
      >
        <mat-option *ngFor="let duration of durationOptions" [value]="duration.value">{{
          duration.label
        }}</mat-option>
      </mat-select>
      <div class="error-message" *ngIf="getFieldError('duration')">
        {{ getFieldError('duration') }}
      </div>
    </div>
  </form>

  <div class="form-actions">
    <button class="cancel-btn" (click)="onCancel()">Cancel</button>
    <button class="save-btn" (click)="onSave()" [disabled]="!appointmentForm.valid">Save</button>
  </div>
</div>
